import { ButtonGroup, ToggleButton } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction } from 'react';
import { generalBlue } from 'src/app-config';
import { useGetIsDarkMode } from 'src/custom-hooks';

type typeOption = {
    label: string;
    type: string;
};

type propsType = {
    additionalKey?: string;
    buttonWidth?: string;
    options: typeOption[];
    radioValue: string | null;
    removeMargin?: boolean;
    setRadioValue: Dispatch<SetStateAction<any>>;
};

export const RadioSelector: FC<propsType> = ({ additionalKey, buttonWidth, options, radioValue, removeMargin, setRadioValue }) => {
    const isDarkMode = useGetIsDarkMode();
    buttonWidth = buttonWidth ?? '220px';

    return (
        <ButtonGroup className={`d-flex flex-column flex-xl-row justify-content-center align-items-center ${removeMargin ? 'my-xl-2' : 'my-4'}`}>
            <style>
                {`
                    @media (max-width: 1200px) {
                        .rounded-sub-xl-0 {border-radius: 0 !important;}
                    }
                `}
            </style>
            {options.map((option, i) =>
                <ToggleButton key={i}
                    id={`radio-${additionalKey ?? ''}${i}`}
                    type={'radio'}
                    className={`${radioValue === option.type ? '' : isDarkMode ? 'bg-lightdark' : 'bg-secondary'} ${!!i ? '' : 'rounded-start-2'} rounded-sub-xl-0 py-2`}
                    style={{
                        backgroundColor: radioValue === option.type ? generalBlue : undefined,
                        maxWidth: buttonWidth,
                        width: buttonWidth
                    }}
                    checked={radioValue === option.type}
                    value={option.type}
                    onChange={e => setRadioValue(e.currentTarget.value)}
                >
                    {option.label}
                </ToggleButton>
            )}
        </ButtonGroup>
    );
}
